"use client";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/lib/types";

const categoryMap: Record<string, string> = {
  1: "Event Creator",
  2: "Event Attendee",
};

export function FAQList({ faqs }: { faqs: FAQ[] }) {
  return (
    <div className="p-4 space-y-2">
      {faqs.map((faq) => (
        <div className="p-2" key={faq.id}>
          <Accordion type="single" collapsible className="w-full">
            <AccordionItem value="item-1" className="border-theme-gray">
              <AccordionTrigger>{faq.question}</AccordionTrigger>
              <AccordionContent>{faq.answer}</AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      ))}
    </div>
  );
}
